import React, { useEffect, useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import SocialWidget from '../Widget/SocialWidget';
import './header.scss';
import ContactInfoWidget from '../Widget/ContactInfoWidget';
import Div from '../Div';
import DropDown from './DropDown';
import styled from 'styled-components';

const StyledSideHeader= styled(Div)`
  .cs-side_header_heading {
    font-weight: 200;
    font-size: 0.9rem;
  }
  .cs-side_header_box {
    padding: 30px 0;
  }
`

export default function Header({ variant }) {
  const [isSticky, setIsSticky] = useState(false);
  const [sideHeaderToggle, setSideHeaderToggle] = useState(false);
  const [mobileToggle, setMobileToggle] = useState(false);
  useEffect(() => {
    window.addEventListener('scroll', () => {
      if (window.scrollY > 0) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    });
  }, []);

  return (
    <>
      <header
        className={`cs-site_header cs-style1 text-uppercase ${
          variant ? variant : ''
        } cs-sticky_header ${isSticky ? 'cs-sticky_header_active' : ''}`}
      >
        <Div className="cs-main_header">
          <Div className="container">
            <Div className="cs-main_header_in">
              <Div className="cs-main_header_left">
                <Link className="cs-site_branding" to="/">
                  <img src="/images/logo.svg" alt="Logo" />
                </Link>
              </Div>
              <Div className="cs-main_header_center">
                <Div className="cs-nav cs-primary_font cs-medium">
                  <ul
                    className="cs-nav_list"
                    style={{ display: `${mobileToggle ? 'block' : 'none'}` }}
                  >
                    <li>
                      <NavLink to="/" onClick={() => setMobileToggle(false)}>
                        Home
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        to="mintcode"
                        onClick={() => setMobileToggle(false)}
                      >
                        MINTCODE
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        to="mintplatform"
                        onClick={() => setMobileToggle(false)}
                      >
                        MINT Platform
                      </NavLink>
                    </li>
                    <li className="menu-item-has-children">
                      <NavLink
                        to="locations"
                        onClick={() => setMobileToggle(false)}
                      >
                        Locations
                      </NavLink>
                      <DropDown>
                        <ul>
                          <li>
                            <Link
                              to="/locations#newyork"
                              onClick={() => setMobileToggle(false)}
                            >
                              New York
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/locations#la"
                              onClick={() => setMobileToggle(false)}
                            >
                              Los Angeless
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/locations#milan"
                              onClick={() => setMobileToggle(false)}
                            >
                              Milan
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/locations#london"
                              onClick={() => setMobileToggle(false)}
                            >
                              London
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/locations#tokyo"
                              onClick={() => setMobileToggle(false)}
                            >
                              Tokyo
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/locations#seoul"
                              onClick={() => setMobileToggle(false)}
                            >
                              Seoul
                            </Link>
                          </li>
                        </ul>
                      </DropDown>
                    </li>
                  </ul>
                  <span
                    className={
                      mobileToggle
                        ? 'cs-munu_toggle cs-toggle_active'
                        : 'cs-munu_toggle'
                    }
                    onClick={() => setMobileToggle(!mobileToggle)}
                  >
                    <span></span>
                  </span>
                </Div>
              </Div>
              <Div className="cs-main_header_right">
                <Div className="cs-toolbox">
                  <span
                    className="cs-icon_btn"
                    onClick={() => setSideHeaderToggle(!sideHeaderToggle)}
                  >
                    <span className="cs-icon_btn_in">
                      <span />
                      <span />
                      <span />
                      <span />
                    </span>
                  </span>
                </Div>
              </Div>
            </Div>
          </Div>
        </Div>
      </header>

      <StyledSideHeader
        className={
          sideHeaderToggle ? 'cs-side_header active' : 'cs-side_header'
        }
      >
        <button
          className="cs-close"
          onClick={() => setSideHeaderToggle(!sideHeaderToggle)}
        />
        <Div
          className="cs-side_header_overlay"
          onClick={() => setSideHeaderToggle(!sideHeaderToggle)}
        />
        <Div className="cs-side_header_in">
          <Div className="cs-side_header_shape" />
          <Link className="cs-site_branding" to="/">
            <img src="/images/mxn_symbol_logo.png" alt="Logo" />
          </Link>
          <Div className="cs-side_header_box">
            <h2 className="cs-side_header_heading">
              MXN Technology is a technology-driven company that is focused on revolutionizing logistics and customer experience in the cross-border e-commerce industry.
            </h2>
          </Div>
          <Div className="cs-side_header_box">
            <ContactInfoWidget title="Contact Us" withIcon />
          </Div>
          <Div className="cs-side_header_box">
            <SocialWidget />
          </Div>
        </Div>
      </StyledSideHeader>
    </>
  );
}
